import routes from './routes';
import { SetRoutes } from 'components';

const FootfallStoreVsVillagePages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default FootfallStoreVsVillagePages;
